import React from "react";
import AboutBanner from "../components/about/about-banner";
import AboutUsFull from "../components/about/about-us-full";
import WhyGels from "../components/about/why-gels";

const About = () => {
  return (
    <>  
        <AboutBanner />
        <AboutUsFull />
        <WhyGels />
    </>

  );
};

export default About;